import { ok } from 'neverthrow';
import type { Graph } from '../../../types/graph';
import type { GraphCommand } from '../types';
import { EffectBuilder } from '../types';
import { InverseDecorator } from '../types';

export const withEffects = (
  command: GraphCommand,
  build: EffectBuilder,
  decorateInverse?: InverseDecorator
): GraphCommand => ({
  ...command,
  apply(graph: Readonly<Graph>) {
    const result = command.apply(graph);
    if (result.isErr()) return result;

    const effects = build({
      before: graph,
      after: result.value.graph,
      command,
    });

    const inverse = decorateInverse
      ? decorateInverse({
          before: graph,
          after: result.value.graph,
          command,
          inverse: result.value.inverse,
        })
      : result.value.inverse;

    return ok({
      ...result.value,
      inverse,
      effects: effects.length > 0 ? effects : undefined,
    });
  },
});
